import {request, serviceUrl} from "@/utils/request";

//获取主机列表
export function gatewayNoticeList(type) {
    return request({
        url: serviceUrl.deviceService + '/device/gateway/notice',
        params: {type}
    })
}

//获取没有配置告警的主机列表
export function saveGatewayNotice(params) {
    return request({
        method: 'POST',
        url: serviceUrl.deviceService + '/device/gateway/notice/save',
        data: params
    })
}
